import { useTranslation } from "react-i18next";
import { createFormContext } from "@mantine/form";
import { Client, ClientSettingsInput } from "src/graphql/generated/graphql";

export const parseClientSettingsInput = (client: Client): ClientSettingsInput => {
    return {
        name: client?.name,
    };
};

export const [ClientSettingsFormProvider, useClientSettingsFormContext, useForm] =
    createFormContext<ClientSettingsInput>();

export const useClientSettingsForm: typeof useForm = (values) => {
    const { t } = useTranslation(["common"]);

    return useForm({
        ...values,
        validate: (values) => ({
            name: !(values?.name?.length > 0) ? t("client_error_missingname") : null,
        }),
    });
};
